import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import {HttpClient} from '@angular/common/http';
import { amenitiesEnum } from 'src/app/components/Station/station-details/device-amenities/amenities.enum';
import { CommonService } from '../common.service';
import { UserInfoService } from '../userInfo.service';

@Injectable({ providedIn: 'root' })
export class ChargeBoxService {
  protected CHARGE_BOX_BASE_PATH = '/charge-boxes';
  constructor(private http: HttpClient,private commonService: CommonService,readonly userInfoService: UserInfoService) {
  }

  isChargeBoxConnected(chargeBoxId: string) {
    return this.http.get(environment.API_BASE_PATH + this.CHARGE_BOX_BASE_PATH + '/' + chargeBoxId + '/statuses');
  }

  getAmenitiesIcon(amenity: string) {
    switch (amenity) {
      case 'Restrooms/Washroom':
      case 'Public Restrooms/Washroom':
        return amenitiesEnum.washroom;
      case 'Auto Service Center':
        return amenitiesEnum.service;
      case 'Car Wash':
        return amenitiesEnum.carWash;
      case 'Air':
      case 'AIR':
        return amenitiesEnum.air;
      case 'Parking':
        return amenitiesEnum.parking;
      case 'Paid Parking':
        return amenitiesEnum.parking;
      case 'ATM':
        return amenitiesEnum.atm;
      case 'Wifi':
        return amenitiesEnum.wifi;
      case 'Pet Friendly':
        return amenitiesEnum.pet;
      case 'Tea/Coffee':
        return amenitiesEnum.cafe;
      case 'Bar/Wine Shop':
        return amenitiesEnum.bar;
      case 'Restaurants':
        return amenitiesEnum.restaurent;
      case 'Pharmacy':
        return amenitiesEnum.pharmacy;
      case 'Hotel':
        return amenitiesEnum.hotel;
      case 'Hospital/Clinic':
        return amenitiesEnum.hospital;
      case 'Cinema':
        return amenitiesEnum.cinema;
      case 'Gym':
        return amenitiesEnum.gym;
      case 'Art':
        return amenitiesEnum.art;
      case 'Library':
        return amenitiesEnum.library;
      case 'Live Music':
        return amenitiesEnum.liveMusic;
      case 'Park':
        return amenitiesEnum.park;
      case 'Kids Play Zone':
        return amenitiesEnum.kidsPlayZone;
      case 'Salon':
        return amenitiesEnum.salon;
      case 'College/School':
        return amenitiesEnum.school;
      case 'Groceries':
        return amenitiesEnum.groceries;
      case 'Shopping Mall':
        return amenitiesEnum.ShoppingMall;
      case 'Beauty Supplies':
        return amenitiesEnum.beauty;
      case 'Electronics':
        return amenitiesEnum.electronics;
      case 'Car Dealers':
        return amenitiesEnum.carDealer;
      case 'Sporting goods':
        return amenitiesEnum.sports;
      default:
        return amenitiesEnum.default;
    }
  }

  getConfigurationList(deviceID){
    let headers = { headers: { 'X-Tenant-ID': this.userInfoService.userDetails.tenantID } }
    return this.commonService.getCall(environment.API_BASE_PATH + `/devices/${deviceID}/configurations/read-write`, headers);
  }
}
